import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoAutomotive = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Automotive</title>
    <circle cx={9.138} cy={22.681} r={2.819} stroke="currentColor" strokeWidth={2} />
    <circle cx={21.821} cy={22.681} r={2.819} stroke="currentColor" strokeWidth={2} />
    <path
      d="M5.536 12.607h-.824c-.67 0-1.212.543-1.212 1.212v7.65c0 .67.543 1.212 1.212 1.212h1.39m-.566-10.074L6.682 7.45c.123-.554.615-.949 1.183-.949H18.46c.405 0 .783.203 1.008.54l3.712 5.567m-17.643 0H26.26a2.609 2.609 0 0 1 2.609 2.609v6.253c0 .67-.543 1.212-1.213 1.212H24.64M11.277 22.681h7.047"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
);
export default SvgIcoAutomotive;
